function loadImages(element, idx) {
  const elementWrapper = element.parentElement;

  window.addEventListener('resize', () => {
    elementWrapper.style.setProperty('--height', `${elementWrapper.clientHeight}px`);
  })

  elementWrapper.style.setProperty('--height', `${elementWrapper.clientHeight}px`);

  if (!shouldLoadMoreImages(element, idx)) {
    document.addEventListener('scroll', onScrollHandler);
  } else {
    prepareAnimation(element);
  }

  function onScrollHandler() {
    if (shouldLoadMoreImages(element, idx)) {
      document.removeEventListener('scroll', onScrollHandler);

      prepareAnimation(element);
    }
  }
}

function shouldLoadMoreImages(element, idx) {
  const rect = element.getBoundingClientRect();

  if ((rect.bottom - rect.height <= (window.innerHeight || document.documentElement.clientHeight) + 300)) {
    animatedImagesDataArray[idx].shift();
    animatedImagesDisplayTimeArray[idx].shift();

    animatedImagesDataArray[idx].forEach((image, imageIdx) => {
      const imageElement = document.createElement('img');

      imageElement.alt = '';
      imageElement.decoding = 'async';
      imageElement.src = image;
      imageElement.style.opacity = "0.01";
      imageElement.dataset.displaytime = animatedImagesDisplayTimeArray[idx][imageIdx];
      imageElement.style.transition = 'none';
      imageElement.style.zIndex = '-1';

      element.appendChild(imageElement);
    })

    return true;
  }

  return false;
}

function isInViewport(element, animationTrigger) {
  const rect = element.getBoundingClientRect();

  switch (animationTrigger) {
    case 'bottom':
      if (rect.bottom - rect.height <= (window.innerHeight || document.documentElement.clientHeight)) {
        initAnimation(element);
        return true;
      }
      return false;
    case 'center':
      if (rect.bottom - rect.height <= (window.innerHeight || document.documentElement.clientHeight) / 2) {
        initAnimation(element);
        return true;
      }
      return false;
    default:
      return false;
  }
}

function prepareAnimation(element) {
  const animationTrigger = element.dataset.animationtrigger;

  if (!isInViewport(element, animationTrigger)) {
    document.addEventListener('scroll', onScrollHandler);
  }

  function onScrollHandler() {
    if (isInViewport(element, animationTrigger)) {
      document.removeEventListener('scroll', onScrollHandler)
    }
  }
}

function initAnimation(element) {
  if (!element.classList.contains('animated-step2') && !element.classList.contains('animated-step3')) {
    const transitionDuration = Number(element.dataset.transitiontime);
    const playMode = element.dataset.playmode;
    const images = element.querySelectorAll('img');
    const numberOfImages = element.querySelectorAll('img').length;

    let currentIndex = 0;
    let direction = 1;

    function imageAnimationHandler() {
      currentIndex = currentIndex + direction;
      const image = images[currentIndex];
      const displayTime = Number(image.dataset.displaytime);

      animation(element, currentIndex);

      if (currentIndex >= numberOfImages - 1 || currentIndex <= 0) {
        switch (playMode) {
          case 'infinite':
            if (!(currentIndex <= 0)) {
              currentIndex = -1;
            }
            break;
          case 'one-time':
            return;
          case 'boomerang':
            direction = direction * (-1);
            break;
          default:
            currentIndex = -1;
            break;
        }
      }

      setTimeout(imageAnimationHandler, (displayTime + transitionDuration) * 1000);
    }

    const image = images[currentIndex];
    const displayTime = Number(image.dataset.displaytime);
    setTimeout(imageAnimationHandler, (displayTime) * 1000);
  }
}

function animation(element, currentIndex) {
  const images = element.querySelectorAll('img');
  const transitionDuration = element.dataset.transitiontime;

  images.forEach((image, idx) => {
    image.style.zIndex = idx === currentIndex ? '-1' : '0';
    image.style.opacity = idx === currentIndex ? "1" : "0";
    image.style.transition = idx !== currentIndex ? `opacity ${transitionDuration}s ease` : `none`;
  })
}

export function initAnimatedImages() {
  document.querySelectorAll('.animated-images').forEach((c, idx) => loadImages(c, idx));
}
